module.exports = __webpack_public_path__ + "28ae233ad5bc40fc3fe009f0c9341e99.pdf";